import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, reset } from 'redux-form';

import EndrosmentForm from '../../components/EndrosmentForm';
import { addEndrosment } from '../../redux/modules/endrosment/action';

class AddEndrosment extends React.Component {
  addEndrosment = (props) => {
    const { dispatch } = this.props;
    dispatch(addEndrosment(props));
    dispatch(reset('addEndrosment'));
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      <EndrosmentForm
        handleSubmit={handleSubmit}
        addEndrosment={this.addEndrosment}
      />
    )
  }
}

export default connect()(reduxForm({
  form: "addEndrosment",
  enableReinitialize: true
})(AddEndrosment));